import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function Portfolio() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("Todos");
  useEffect(() => { api.get("/portfolio").then((r) => setItems(r.data)).catch(() => {}); }, []);
  const cats = ["Todos", ...Array.from(new Set(items.map((i) => i.category)))];
  const filtered = filter === "Todos" ? items : items.filter((i) => i.category === filter);
  return (
    <div className="anim-in">
      <div className="border-b border-border">
        <div className="container-x py-16">
          <p className="tech-label mb-3">Portefólio</p>
          <h1 className="text-5xl lg:text-6xl font-bold tracking-tighter">Trabalhos realizados.</h1>
          <p className="mt-5 text-muted-foreground max-w-2xl">
            Uma seleção dos projetos que desenvolvemos, dos protótipos às pequenas séries.
          </p>
          <div className="mt-8 flex flex-wrap gap-2">
            {cats.map((c) => (
              <button key={c} onClick={() => setFilter(c)} data-testid={`portfolio-filter-${c}`} className={`text-xs px-3 py-1.5 rounded-full border ${filter === c ? "bg-foreground text-background border-foreground" : "border-border text-muted-foreground hover:text-foreground"}`}>{c}</button>
            ))}
          </div>
        </div>
      </div>
      <div className="container-x py-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {filtered.map((p) => (
          <Link key={p.slug} to={`/portfolio/${p.slug}`} className="group border border-border overflow-hidden bg-card">
            <div className="aspect-[4/3] bg-secondary overflow-hidden">
              {p.images?.[0] && <img src={p.images[0]} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform" />}
            </div>
            <div className="p-5">
              <p className="tech-label">{p.category}</p>
              <h3 className="font-semibold mt-2">{p.title}</h3>
              <p className="text-sm text-muted-foreground mt-2 line-clamp-2">{p.problem}</p>
              <div className="mt-4 flex items-center justify-between mono text-[10px] uppercase text-muted-foreground">
                <span>{p.material}</span>
                <span className="inline-flex items-center gap-1 text-brand">Ver <ArrowRight size={12} /></span>
              </div>
            </div>
          </Link>
        ))}
        {filtered.length === 0 && <div className="col-span-full text-center text-muted-foreground py-10 tech-label">sem projetos publicados</div>}
      </div>
    </div>
  );
}

export function PortfolioDetail() {
  const { slug } = useParams();
  const [item, setItem] = useState(null);
  useEffect(() => { api.get(`/portfolio/${slug}`).then((r) => setItem(r.data)).catch(() => setItem(false)); }, [slug]);
  if (item === null) return <div className="container-x py-20 tech-label">a carregar…</div>;
  if (!item) return <div className="container-x py-20"><p className="tech-label">projeto não encontrado</p><Link to="/portfolio" className="btn-outline mt-4">Voltar</Link></div>;
  return (
    <div className="anim-in">
      <div className="container-x py-14">
        <p className="tech-label mb-3">{item.category}</p>
        <h1 className="text-4xl lg:text-5xl font-bold tracking-tighter max-w-3xl">{item.title}</h1>
        <div className="mt-10 grid lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2 space-y-6">
            {item.images?.map((img, i) => (
              <div key={i} className="aspect-video border border-border overflow-hidden bg-secondary">
                <img src={img} alt={`${item.title} ${i + 1}`} className="w-full h-full object-cover" />
              </div>
            ))}
            <Field label="Problema" value={item.problem} />
            <Field label="Solução" value={item.solution} />
            <Field label="Processo" value={item.process} />
            <Field label="Resultado" value={item.result} />
            {item.testimonial && <Field label="Testemunho" value={`“${item.testimonial}”`} />}
          </div>
          <div className="border border-border p-6 h-fit sticky top-20 space-y-4 bg-card">
            <Meta label="Material" value={item.material} />
            <Meta label="Tecnologia" value={item.technology} />
            <Meta label="Cliente" value={item.client_name || "Anónimo"} />
            <Meta label="Categoria" value={item.category} />
            <Link to="/pedido-orcamento" className="btn-primary w-full justify-center mt-4">Projeto semelhante</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

const Field = ({ label, value }) =>
  value ? (
    <div>
      <p className="tech-label mb-2">{label}</p>
      <p className="text-sm leading-relaxed">{value}</p>
    </div>
  ) : null;

const Meta = ({ label, value }) => (
  <div className="flex items-center justify-between text-sm">
    <span className="tech-label">{label}</span>
    <span className="font-medium">{value || "—"}</span>
  </div>
);
